import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

const STREAMS = [
  "Digital & Social Listening",
  "PRO & Survey Evidence",
  "Patient Advisory Input",
  "Real-World Data & Evidence",
  "Regulatory & HTA Context",
];

export default function PentaVoiceSummary() {
  return (
    <section
      className="bg-ink-2 relative border-t border-white/[0.06]"
      data-testid="pentavoice-summary-section"
    >
      <div className="container-edge py-24 lg:py-32">
        <div className="grid grid-cols-12 gap-x-8 gap-y-12">
          <Reveal className="col-span-12 lg:col-span-5">
            <div className="eyebrow">The framework</div>
            <h2
              className="font-serif font-normal text-4xl md:text-5xl lg:text-[3.75rem] tracking-tight mt-4 text-parchment-bright leading-[1.05]"
              data-testid="pentavoice-headline"
            >
              PentaVoice<sup className="text-[0.35em] align-super ml-1 text-rust">™</sup>
            </h2>
            <p className="mt-5 font-serif italic text-xl md:text-2xl text-parchment/85 leading-snug max-w-md">
              Five evidence streams. One patient-evidence narrative.
            </p>
            <p className="mt-7 text-parchment/75 text-[15.5px] leading-relaxed max-w-md">
              PentaVoice<sup className="text-[0.55em] align-super">™</sup> is the framework behind Voice2Evidence.
            </p>
            <p className="mt-5 text-parchment/70 text-[14.5px] leading-relaxed max-w-md">
              Together, these streams help identify, validate, and translate patient voice into evidence that teams can act upon.
            </p>
            <div className="mt-8 font-mono text-[12.5px] uppercase tracking-[0.22em] text-rust">
              Voice → Evidence → Strategy
            </div>
            <div className="mt-8">
              <Link
                to="/framework"
                className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-rust hover:text-parchment-bright transition-colors"
                data-testid="pentavoice-learn-more"
              >
                <span>Explore the framework</span>
                <span aria-hidden="true" className="text-[14px] leading-none">→</span>
              </Link>
            </div>
          </Reveal>

          <Reveal className="col-span-12 lg:col-span-7" delay={120}>
            <div
              className="bg-ink-1 border border-white/[0.08] p-7 lg:p-9"
              data-testid="pentavoice-streams"
            >
              <div className="font-mono text-[10.5px] uppercase tracking-[0.22em] text-rust mb-6">
                It combines
              </div>
              <ul className="divide-y divide-white/[0.06]">
                {STREAMS.map((s, i) => (
                  <li
                    key={s}
                    className="flex items-baseline gap-5 py-4 first:pt-0 last:pb-0"
                    data-testid={`pentavoice-stream-l${i + 1}`}
                  >
                    <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-rust shrink-0 w-10">
                      L{i + 1}
                    </span>
                    <span className="font-serif text-[1.4rem] md:text-[1.6rem] text-parchment-bright leading-snug">
                      {s}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
